import React, { Component } from 'react';

// Date airbnb
import 'react-dates/initialize'; // <---- put this at the very top of your js file fix issues: https://github.com/airbnb/react-dates/issues/750

import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
// import moment from "moment";
import '../../../../assets/custome/css/react_dates_overrides.css';

export default class DateRangePickerWrapper extends Component {

  constructor(props) {
    super(props);
    this.state = {
      focused: props.autoFocus,
      date: props.initialDate,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDateChange(date) {
    this.setState({ date });
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  render() {
    /*const { focused, date } = this.state;*/
    return(
      <DateRangePicker
        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/home/components/DateRangePickerWrapper.js